import { api } from "./api";

export const MEMORIA_TOKEN_KEY = "arcana-memoria-token";
export const getMemoriaToken = () => sessionStorage.getItem(MEMORIA_TOKEN_KEY);
export const mHeaders = () => ({ headers: { "X-Memoria-Token": getMemoriaToken() } });
export const mApi = {
  get: (p) => api.get(p, mHeaders()),
  post: (p, body) => api.post(p, body, mHeaders()),
  put: (p, body) => api.put(p, body, mHeaders()),
  delete: (p) => api.delete(p, mHeaders()),
};
